<template>
    <div id="map">
        <iframe :src="map.contact_content" v-for="map of contactMap" :key="map.contact_content"></iframe>
    </div>
</template>

<script>

import axios from "axios";

export default {
    name: 'Map',
    props: ['pathUrl'],

    created() {
        this.getContactMap();
    },
    data() {
        return {
            contactMap: [],
            errors: []
        };
    },
    methods: {
        getContactMap() {
            axios.get(this.pathUrl + "?data=map")
                .then(response => (this.contactMap = response.data.result))
                .catch(error => {
                    this.errors.push(error);
                });
        }
    }
}
</script>